module.exports = __webpack_public_path__ + "res/Roboto-Bold-webfont.svg?31df46a86eb21e1a5e92798535939154";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/roboto/Roboto-Bold-webfont.svg
// module id = 30
// module chunks = 0